import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import {store} from './store';
import Meta from './assets/js/Meta';

//import E404 from './vue_components/E404.vue'
const E404 = () => import(/* webpackChunkName: "E404" */ './vue_components/E404.vue');

//import Index from '@pages/index.js'
let name = '/* webpackChunkName: "index" */';
const Index = () => import(/* webpackChunkName: "index" */ './templates/pages/index.js');

const Collection = () => import(/* webpackChunkName: "collection" */ '@pages/collection/index.js');

//import CollectionView from '@pages/collection/view/index.js'
const CollectionView = () => import(/* webpackChunkName: "collectionView" */ '@pages/collection/view/index.js');

const Author = () => import(/* webpackChunkName: "authorView" */ '@pages/author/view/index.js');

//import Cart from '@pages/cart/index.vue'
const Cart = () => import( /* webpackChunkName: "cart" */'@pages/cart/index.vue');

const Favorite = () => import(/* webpackChunkName: "favorite" */ '@pages/favorite/index.vue');

//import About from '@pages/about/index.js'
const About = () => import(/* webpackChunkName: "about" */ '@pages/about/index.js');
//import Type from '@pages/type/index.js'
const Type = () => import(/* webpackChunkName: "type" */ '@pages/type/index.js');

const Search = () => import(/* webpackChunkName: "search" */ '@pages/search/index.js');

const Blog = () => import(/* webpackChunkName: "blog" */ '@pages/blog/index.js');
const BlogView = () => import(/* webpackChunkName: "blogView" */ '@pages/blog/view/index.js');

const Done = () => import(/* webpackChunkName: "done" */ '@pages/done/index.vue');

//import Reload from './vue_components/reload'
const Reload = () => import(/* webpackChunkName: "reload" */ './vue_components/reload');

const routes = [
    {
        path: '',
        component: Index,
        name: 'main',
    },
    {
        path: '/collection',
        component: Collection,
        name: 'collection'
    },
    {
        path: '/collection/:id',
        component: CollectionView,
        name: 'collectionView'
    },
    {
        path: '/author/:id',
        component: Author,
        name: 'author'
    },
    {
        path: '/cart',
        component: Cart,
        name: 'cart'
    },
    {
        path: '/about',
        component: About,
        name: 'about'
    },
    {
        path: '/favorite',
        component: Favorite,
        name: 'favorite'
    },
    {
        path: '/blog',
        component: Blog,
        name: 'blog'
    },
    {
        path: '/blog/:id',
        component: BlogView,
        name: 'blogView'
    },
    {
        path: '/search',
        component: Search,
        name: 'search',
    },
    {
        path: '/done',
        component: Done,
        name: 'done',
    },
    {
        path: '/:type',
        component: Type,
        name: 'type'
    },
    {
        path: '/reload',
        name: 'reload',
        component: Reload,
    },
    {
        path: '/404',
        component: E404,
        name: 'e404'
    },
    {
        path: '*',
        component: E404
    }
];

export const router = new VueRouter({
    routes,
    base: '/',
    mode: 'history',
    scrollBehavior (to, from) {
        // скроллим вверх только если не нажали на кнопку показать еще на странице коллекции
        let isTabsAuthor = from.path.indexOf('author') !== -1 && to.path.indexOf('author') !== -1;
        if ((!to.query.curentPage || to.query.curentPage === from.query.curentPage) && !isTabsAuthor) {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve({x: 0, y: 0})
                }, 500)
            })
        }
    }
});

router.beforeEach((to, from, next) => {
    store.dispatch('locale/LoadLocale').then(() => {
        next();
    }, (newPath) => {
        next(newPath);
    });
});

router.afterEach((to, from) => {
    if (store.state.meta.items[to.path] === undefined){
        store.dispatch('meta/loadItems', to).then(() => {
            Meta(store, to);
        });
    } else {
        Meta(store, to);
    }
});



// WEBPACK FOOTER //
// ./src/routes.js